<template>
  <div>
    <WebsiteHeader
      @get-school-logo="getSchoolLogo"
      class="pb-16"
    ></WebsiteHeader>
    <div class="wrapper">
      <div class="text-center mt-4 name" :style="{ color: getThemeColor }">
        {{ getUserSchool.schname }}
      </div>
      <div class="p-3 mt-3">
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fa fa-user"></span> -->
          <v-icon>mdi-email</v-icon>
          <input v-model="email" type="email" placeholder="Email" />
        </div>
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fas fa-key"></span> -->
          <v-icon>mdi-account-lock</v-icon>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="Password"
          />
        </div>
        <div class=" d-flex align-items-center">
          <input type="checkbox" @click="showPassword()" /><label
            @click="showPassword()"
            >&nbsp;&nbsp;Show Password</label
          >
        </div>

        <v-btn
          align="right"
          small
          class="btn mt-3"
          :color="getThemeColor"
          dark
          @click.prevent="login"
          rounded
          >User Login</v-btn
        >
      </div>
      <div class="text-center fs-6 mt-4">
        <v-btn
          x-small
          rounded
          class="ml-3"
          dark
          color="red"
          style="margin-right: 10px; margin-bottom: 10px"
          @click="goTo('/reset-password')"
          ><v-icon x-small>mdi-account-lock</v-icon>Reset Password</v-btn
        >

        <v-btn
          x-small
          rounded
          color="#0077DD"
          dark
          @click="goTo('/register')"
          class="mt-n2"
          ><v-icon x-small>mdi-account-plus</v-icon>Create Account</v-btn
        >
      </div>
    </div>
    <TemplateFooter></TemplateFooter>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import TemplateFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";

export default {
  components: {
    WebsiteHeader,
    TemplateFooter,
  },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  data: () => ({
    schoolLogo: null,
    email: null,
    password: null,
  }),
  methods: {
    goTo(path) {
      this.$router.push({ path });
    },
    showPassword() {
      const passwordInput = document.getElementById("password");
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    },
    getSchoolLogo(logo) {
      this.schoolLogo = logo;
    },
    async login() {
      const loggegIn = await helpersJs.login(this.email, this.password);
      if (loggegIn) {
        this.$toast.success("Login Successful, Welcome!", { duration: 4000 });
        if (this.getUserSchool && this.getUserSchool.emis == "700369007") {
          this.$router.push({ path: "/add-your-school" });
        } else {
          this.$router.push({ name: "switchboard" });
        }
      } else {
        this.$toast.error("Email or Password Incorrect!", { duration: 4000 });
      }
    }, //end of login method
  },
};
</script>

<style scoped>
/* Importing fonts from Google */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

/* Reseting */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  background: #ecf0f3;
}

.wrapper {
  max-width: 350px;
  min-height: 500px;
  margin: 130px auto;
  padding: 40px 30px 30px 30px;
  background-color: #ecf0f3;
  border-radius: 15px;
  box-shadow: 13px 13px 20px, -13px -13px 20px;
}

.logo {
  width: 80px;
  margin: auto;
}

.logo img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0px 0px 3px #5f5f5f, 0px 0px 0px 5px #ecf0f3, 8px 8px 15px #a7aaa7,
    -8px -8px 15px #fff;
}

.wrapper .name {
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 1.3px;
  padding-left: 10px;
  color: #555;
}

.wrapper .form-field input {
  width: 100%;
  display: block;
  border: none;
  outline: none;
  background: none;
  font-size: 1.2rem;
  color: #666;
  padding: 10px 15px 10px 10px;
  /* border: 1px solid red; */
}

.wrapper .form-field {
  padding-left: 10px;
  margin-bottom: 20px;
  border-radius: 20px;
  box-shadow: inset 8px 8px 8px #cbced1, inset -8px -8px 8px #fff;
}

.wrapper .form-field .fas {
  color: #555;
}

.wrapper .btn {
  box-shadow: none;
  width: 100%;
  height: 40px;
  background-color: #03a9f4;
  color: #fff;
  border-radius: 25px;
  box-shadow: 3px 3px 3px #b1b1b1, -3px -3px 3px #fff;
  letter-spacing: 1.3px;
}

.wrapper .btn:hover {
  background-color: #039be5;
}

.wrapper a {
  text-decoration: none;
  font-size: 0.8rem;
  color: #03a9f4;
}

.wrapper a:hover {
  color: #039be5;
}

@media (max-width: 380px) {
  .wrapper {
    margin: 30px 20px;
    padding: 40px 15px 15px 15px;
  }
}
</style>
